<template>
  <div class="filter-section__wrapper">
    <div class="filter-section__fields">
      <hotel-date-picker
          :format="inputFormat"
          :i18n=this.lang.i18n
          :minNights=this.minreservationdays
          :startDate="moment().hour() > 17 ?
                new Date(new Date().setDate(new Date().getDate() + 1)) :
                new Date()"
          @check-in-changed="value => {this.start = value; evalSubmitState();}"
          @check-out-changed="value => {this.end = value; evalSubmitState();}"
      />
      <div class="filter-section__input-group">
        <div class="filter-section__input-group-item">
          <CustomSelect
            id="type"
            color="white"
            name="type"
            :icon="vehicle_icon"
            :placeholder="lang.vehicle_type_select"
            :options="options"
            :value="type"
            @input="updateField"
          />
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-light btn-lg"
      :disabled="disabled"
      @click="submit"
    >
      {{ lang.search }} <i class="fa fa-search" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
  import HotelDatePicker from 'vue-hotel-datepicker'
  import 'vue-hotel-datepicker/dist/vueHotelDatepicker.css'

  import CustomInput from './CustomInput.vue'
  import CustomSelect from './CustomDropdown.vue'
  import moment from "moment";

  const INPUT_FORMAT = 'DD/MM/YYYY'
  const SUBMIT_FORMAT = 'YYYY-MM-DD'

  export default {
    components: {
      HotelDatePicker,
      CustomInput,
      CustomSelect
    },
    props: {
      lang: {
        required: true,
        type: Object
      },
      vehicle_types: {
        required: true,
        type: Object
      },
      minreservationdays: {
          required: true,
          type: Number
      },
        vehicle_icon: {
        required: true,
        type: Text
    },
        default_vehicle: {
        required: true,
        type: Text
    }
    },
    data() {
      return {
        disabled: true,
        type: this.default_vehicle,
        start: '',
        end: '',
        inputFormat: INPUT_FORMAT
      }
    },
    computed: {
        moment() {
            return moment
        },
      options() {
        return this.vehicle_types
          .map((value) => ({ key: value, text: this.lang.i18n[value] }))
          .filter(({ key, text }) => key && text)
      }
    },
    methods: {
      updateField({ name, value }) {
        this[name] = value
        this.evalSubmitState()
      },
      evalSubmitState() {
        let cond1 = this.type === "" || this.start === ""|| this.end === ""
        let cond2 = !Date.parse(this.start) || !Date.parse(this.end)
        this.disabled = cond1 || cond2
      },
      submit(){
        let params = {
          type: this.type,
          start: window.moment(this.start).format(SUBMIT_FORMAT) + ' 09:00:00',
          end: window.moment(this.end).format(SUBMIT_FORMAT)  + ' 09:00:00',
        }
        let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        window.location.href= '/' + bike.locale + '/lanzarote/search?' + queryString
      }
    }
  }
</script>

<style>
.filter-section {
  background-color: black;
  position: relative;
  z-index: 10;
}

.filter-section__wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem 0;
}

.filter-section__input-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 0.75rem;
  border: 1px solid white;
  border-radius: 21px;
  min-height: 2.5rem;
}

.filter-section__input-group > * {
  padding: 0.5rem 1rem;
  flex: 1;
}

.filter-section__input-group > * + * {
  border-left: 1px solid white;
}

  @media (min-width: 993px) {
    .filter-section {
        background-color: transparent;
        margin-top: -80px;
    }

    .filter-section__wrapper {
      flex-direction: row;
      justify-content: space-between;
      gap: 1.5rem;
      padding: 2.5rem;
      background-color: #1a1a1a;
      border-radius: 16px;
      box-shadow: 0 20px 50px rgba(0,0,0,0.6), 0 0 15px rgba(255,255,255,0.05);
      border: 1px solid #444;
    }

    .filter-section__input-group {
      margin-top: 0;
      flex: 1;
      min-height: 4rem;
      border-radius: 8px;
    }

    .filter-section__input-group > * {
        padding: 0.75rem 1.25rem;
    }

    .filter-section__fields {
        gap: 1rem;
        flex: 1;
    }

    .btn-lg {
        padding: 1rem 2.5rem;
        font-size: 1.25rem;
        border-radius: 8px;
    }

    .custom-select {
        font-size: 1.1rem;
        height: 100%;
    }

    .custom-select ::v-deep .dropdown-selected {
        font-size: 1.1rem;
    }
}

.filter-section__fields {
  flex: 66.66%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.vhd__datepicker__wrapper {
  flex: 1;
  background: transparent;
  display: inline-block;
  height: auto;
  position: relative;
}

.vhd__datepicker__dummy-wrapper {
  width: 100%;
  height: 100%;
  border: none;
  cursor: initial;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
}

.vhd__datepicker__input:first-child {
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3E%3C/svg%3E);
  background-position: right 1rem center;
  background-repeat: no-repeat;
  background-size: 1rem 0.75rem;
}

.vhd__datepicker__input {
  position: relative;
  flex: 1;
  height: 2.5rem;
  background-color: transparent;
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3E%3C/svg%3E);
  background-position: right 1rem center;
  background-repeat: no-repeat;
  background-size: 1rem 0.75rem;
  border: 0;
  color: white;
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.5rem;
  outline: none;
  padding: 0.5rem 1.5rem;
  text-align: left;
  border: 1px solid white;
  border-radius: 21px
}

@media (min-width: 993px) {
    .vhd__datepicker__input {
        height: 4rem;
        font-size: 1.1rem;
        border-radius: 8px;
        padding: 0.75rem 1.5rem;
    }
}

.vhd__datepicker__input:before {
  content: "\f073";
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
}

.vhd__datepicker__clear-button {
  display: none;
}

@media (min-width: 993px) {
  .vhd__datepicker__wrapper {
    width: 60%;
  }
}
</style>
